// 使用CDN引入的全局变量
const { createApp } = Vue
import App from './App.vue'
import routerConfig from './router'
import { getApiBaseUrl } from './utils/runtime'

// 配置axios全局实例
const api = axios.create({
  baseURL: getApiBaseUrl(),
  timeout: 30000
})

const app = createApp(App)
app.use(ElementPlus)
app.use(routerConfig)

// 将api实例挂载到全局
app.config.globalProperties.$api = api

app.mount('#app')
